import { Controller, useFormContext } from "react-hook-form";

import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { PaymentTermSelect } from "@/features/payment-terms";
import { SellerBankAccountsSection } from "@/features/seller-bank-accounts";

export const ProcurementSection = () => {
  const { control } = useFormContext();

  return (
    <Grid container spacing={3}>
        <Grid size={12}>
          <Typography variant="h6">Pembelian</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Controller
            control={control}
            name="defaultPaymentTerm"
            render={({ field, fieldState }) => (
              <PaymentTermSelect
                value={field.value}
                onChange={field.onChange}
                TextFieldProps={{
                  required: true,
                  label: "Default Syarat Pembayaran",
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                  InputProps: {
                    placeholder: "Pilih",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid size={12}>
          <SellerBankAccountsSection />
        </Grid>
      </Grid>
  );
};

export default ProcurementSection;
